<template>
  <div>
    <v-container fluid>
      <div class="text-h6 white--text" style="margin-top: 10px;">Pagamento com Cartão de Crédito</div>
      <v-card class="rounded-t-xl">
        <CardForm
          :form-data="formData"
        />
      </v-card>
      <v-dialog :value="dialogCartao" persistent>
        <v-alert v-if="erroAjax" prominent type="error" icon="mdi-cloud-alert">
          {{ erroAjax }}
        </v-alert>
        <v-card v-else>
          <v-card-text class="text-h6 text-center">
          Por favor aguarde o processamento do cartão
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog :value="successCartao" persistent>
        <v-card>
          <v-card-text class="text-h6 text-center green white--text">
            Pagamento efetuado com sucesso, você está sendo redirecionado
          <v-progress-linear indeterminate color="white"></v-progress-linear>
          </v-card-text>
        </v-card>
    </v-dialog>
    </v-container>
  </div>
</template>
<script>
import CardForm from '@/components/CardForm'
import { mapState } from 'vuex'

export default {
  name: 'CadastroCliente',
  components: {
    CardForm
  },
  computed: {
    ...mapState(['dialogCartao', 'erroAjax', 'successCartao'])
  },
  data: () => ({
    formData: {
      cardName: '',
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCvv: ''
    }
  })
}
</script>
<style lang="scss">
@import '../../assets/style.scss';
</style>
